package xyz.malefic.multipage

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.boxSizing
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Style
import xyz.malefic.multipage.i18n.LanguageProvider
import xyz.malefic.multipage.styles.Theme

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        GlobalStyles()

        LaunchedEffect(Unit) {
            js("document.title = 'LivStay Japan - 空き家管理・不動産活用サービス'")
            js("var link = document.querySelector(\"link[rel*='icon']\") || document.createElement('link'); link.type = 'image/svg+xml'; link.rel = 'icon'; link.href = '/favicon.svg'; document.head.appendChild(link)")
            js("var ml = document.createElement('link'); ml.rel = 'stylesheet'; ml.href = '/mobile.css'; document.head.appendChild(ml)")
            js("var vp = document.querySelector('meta[name=viewport]'); if(!vp){vp=document.createElement('meta');vp.name='viewport';document.head.appendChild(vp);} vp.content='width=device-width, initial-scale=1.0'")
        }

        Surface(Modifier.minHeight(100.vh)) {
            LanguageProvider {
                content()
            }
        }
    }
}

@Composable
private fun GlobalStyles() {
    Style {
        """
        @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@300;400;500;700&family=Zen+Kurenaido&family=Shippori+Mincho:wght@400;500;600&family=M+PLUS+Rounded+1c:wght@300;400;500;700&display=swap');
        """.trimIndent()

        "body" style {
            margin(0.px)
            padding(0.px)
            fontFamily(Theme.FontFamily)
            fontSize(16.px)
            lineHeight(1.6.em)
            backgroundColor(Theme.Background)
            color(Theme.TextPrimary)
        }

        "*" style {
            boxSizing("border-box")
        }

        "html" style {
            margin(0.px)
            padding(0.px)
            property("scroll-behavior", "smooth")
        }

        "::before, ::after" style {
            boxSizing("border-box")
        }

        "body::before, html::before" style {
            property("content", "''")
            display(DisplayStyle.None)
        }

        "::-webkit-scrollbar" style {
            width(8.px)
        }

        "::-webkit-scrollbar-track" style {
            backgroundColor(Theme.SurfaceVariant)
        }

        "::-webkit-scrollbar-thumb" style {
            backgroundColor(Theme.PrimaryLight)
            property("border-radius", "4px")
        }

        "::-webkit-scrollbar-thumb:hover" style {
            backgroundColor(Theme.Primary)
        }
    }
}

@InitKobweb
fun initKobweb(
    @Suppress("UNUSED_PARAMETER") ctx: InitKobwebContext,
) {
}

@InitSilk
fun initSilk(
    @Suppress("UNUSED_PARAMETER") ctx: InitSilkContext,
) {
}
